export default {
    or: 'or',
    privacy: {
        url: 'https://rountine.com/en/privacy/',
        link: 'Privacy policy',
        pageLink: 'Privacy policy — rountine.com',
    },
    fields: {
        email: 'Email',
        emailPlaceholder: 'you{\'@\'}example.com',
        password: 'Password',
        repeatPassword: 'Repeat password',
    },
    password: {
        show: 'Show password',
        hide: 'Hide password',
        tooShort: 'Your password must be at least 8 characters long.',
        mismatch: 'The passwords don’t match.',
        minPlaceholder: 'at least 8 characters',
    },
    google: {
        unverifiedEmail: 'This Google account doesn’t have a verified email address.',
        failed: 'Signing in with Google didn’t work. Try again or sign in with your password.',
    },
    login: {
        subtitle: 'Sign in to continue',
        resetDone: 'Your password has been changed. Sign in with your new password.',
        accountDeleted: 'Your account and all your data have been deleted.',
        invalid: 'Incorrect email or password.',
        failed: 'Signing in didn’t work. Please try again.',
        forgot: 'Forgotten your password?',
        submit: 'Sign in',
        submitting: 'Signing in…',
        noAccount: 'Don’t have an account?',
    },
    register: {
        subtitle: 'Create a new account',
        emailTaken: 'This email is already taken.',
        failed: 'Sign-up didn’t work. Please try again.',
        submit: 'Sign up',
        submitting: 'Creating your account…',
        acceptPolicy: 'By creating an account, you accept the {policy}.',
        policyLink: 'privacy policy',
        haveAccount: 'Already have an account?',
    },
    reset: {
        subtitleRequest: 'Reset your password',
        subtitleConfirm: 'Enter the code and a new password',
        requestIntro: 'Enter your account’s email address. If it exists, we’ll send a 6-digit code to it.',
        send: 'Send code',
        sending: 'Sending…',
        sendFailed: 'Couldn’t send the code. Please try again.',
        tooManyIn: 'Several codes have already been sent to this address. You can send another in {minutes} min — check your spam folder too.',
        tooManyLater: 'Several codes have already been sent to this address. You can send another a bit later — check your spam folder too.',
        codeSent: 'We’ve sent a code to {email}.',
        code: 'Code from the email',
        codeInvalid: 'The code must be 6 digits.',
        codeWrong: 'The code is incorrect or has expired.',
        newPassword: 'New password',
        change: 'Change password',
        changing: 'Changing…',
        changeFailed: 'Couldn’t change the password. Please try again.',
        noCode: 'No code?',
        resend: 'Send again',
        remember: 'Remember your password?',
    },
};
